import { BaseService } from '@/services/base.service'

export class GetManualSalaryService extends BaseService {
  static get entity () {
    return '/payslip';
  }
}

export class UploadFileSalaryService extends BaseService {
  static get entity () {
    return '/payslip/payslip-upload';
  }
}

export class GetEmployePaySlip extends BaseService {
  static get entity () {
    return '/payslip/employee-payslip';
  }
}
